const MENUS_TYPE = {
    breakFast: 'BREAKFAST',
    mainCourse: 'MAINCOURSE',
    snacks: 'SNACKS',
    desserst: 'DESSERTS',
    drinks:'DRINKS'
}

export default MENUS_TYPE